/**
 * @module editableField/editableField
 */

import { Plugin } from 'ckeditor5/src/core';
import EditableFieldUI from './ui/EditableFieldUI';
import EditableFieldEditing from './EditableFieldEditing';
import { enableEditableFieldCommandsOnRestrictedMode } from './utils';

import '../theme/editableField.css';

/**
 * The Editable Field plugin
 *
 * @extends module:core/plugin~Plugin
 */
export default class EditableField extends Plugin {
	/**
	 *
	 * @returns {string}
	 */
	static get pluginName() {
		return 'EditableField';
	}

	/**
	 *
	 * @returns {(EditableFieldEditing|EditableFieldUI)[]}
	 */
	static get requires() {
		return [ EditableFieldEditing, EditableFieldUI ];
	}

	afterInit() {
		enableEditableFieldCommandsOnRestrictedMode( this.editor.plugins );
	}
}
